import type { Job } from "../types/Job";

/**
 * Whether a job has been sampled (its "Sample Date" is set). MC's scheduling job view
 * ('App View - Schedule Jobs') drops sampled jobs — they're finished work — so they don't
 * count toward a shift's job total or appear in its row list. Mirrors the `unsampledByJobId`
 * flag the scheduling map builds from `!dateSampled`; `dateSampled` already folds in the
 * manual-override date (it maps from the "Sample Date" formula).
 */
export function isJobSampled(job: Pick<Job, "dateSampled">): boolean {
	return job.dateSampled != null;
}
